export default __webpack_public_path__ + "static/media/exit-to-app.24f74618.svg";